export default function SenderNumberTab() {
  return (
    <div className="space-y-4 md:space-y-6 overflow-hidden">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 md:gap-3 min-w-0">
        <div className="min-w-0">
          <h2 className="text-white font-bold text-base md:text-lg">발신번호 관리</h2>
          <p className="text-gray-500 text-[11px] md:text-sm mt-0.5">발신번호 설정 안내</p>
        </div>
      </div>

      {/* Info banner — 발신번호 등록 불필요 안내 */}
      <div className="flex items-start gap-2.5 md:gap-3 bg-emerald-500/10 border border-emerald-500/25 rounded-xl p-4 md:p-6">
        <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-emerald-500/20 shrink-0 mt-0.5">
          <i className="ri-check-line text-emerald-400 text-lg md:text-xl"></i>
        </div>
        <div className="min-w-0">
          <p className="text-emerald-300 text-sm md:text-base font-semibold">발신번호 등록이 필요하지 않습니다</p>
          <p className="text-emerald-400/70 text-xs md:text-sm mt-2 leading-relaxed">
            모든 문자 메시지는 <strong className="text-emerald-300">001 국제전화</strong> 번호로 통합 발송됩니다.
            별도의 발신번호를 등록하지 않아도 바로 문자 발송이 가능합니다.
          </p>
          <div className="mt-4 p-3 md:p-4 bg-emerald-500/[0.06] rounded-xl border border-emerald-500/15">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line text-emerald-400 text-sm"></i>
              </div>
              <span className="text-emerald-300 text-xs md:text-sm font-medium">어떻게 이용하나요?</span>
            </div>
            <ul className="space-y-1.5 text-emerald-400/70 text-[11px] md:text-xs">
              <li className="flex items-start gap-2">
                <span className="text-emerald-500 mt-0.5">·</span>
                <span>발신번호 등록 절차 없이 바로 <strong className="text-emerald-300">문자 발송</strong> 페이지에서 발송하세요.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-emerald-500 mt-0.5">·</span>
                <span>대시보드의 <strong className="text-emerald-300">빠른 발송</strong>에서도 즉시 이용할 수 있습니다.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-emerald-500 mt-0.5">·</span>
                <span>수신자에게는 <strong className="text-emerald-300">001 국제전화</strong> 발신번호로 표시됩니다.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* 기존 등록 발신번호가 있는 경우 안내 */}
      <div className="flex items-start gap-2.5 md:gap-3 bg-white/[0.03] border border-white/[0.07] rounded-xl p-4 md:p-5">
        <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center shrink-0 mt-0.5">
          <i className="ri-history-line text-gray-400 text-sm md:text-base"></i>
        </div>
        <div className="min-w-0">
          <p className="text-gray-300 text-xs md:text-sm font-medium">기존에 등록된 발신번호는 어떻게 되나요?</p>
          <p className="text-gray-500 text-[11px] md:text-xs mt-1.5 leading-relaxed">
            이전에 등록하신 발신번호들은 발송 이력에서 참조용으로만 보관됩니다.
            실제 발송 시에는 항상 001 국제전화 번호로 통일되어 발송되므로, 추가 관리가 필요하지 않습니다.
          </p>
        </div>
      </div>
    </div>
  );
}